import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AerialMenu } from '../../util/aerial-menu.model';

@Component({
  selector: 'aerial-header-menu',
  templateUrl: './aerial-header-menu.template.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AerialHeaderMenuComponent extends AerialMenu {}
